/*DIVISION / ACTIVITY ASSIGNMENTS*/
Vue.component('brieffields', {
    template:'#brieffields-template',

    data:function(){
        return{
            divisions: [],
            brief_fields: [],
            searchString:'',
            assignmentData:[],
            modal:'',
            head:'',
            tableHeight:'',
            tableOffset:'',
            activeDivisionId:1,
            activeDivision:{},
            filteredActivities:{},
            selectedActivityId: '-1'
        };
    },
    watch:{
        activeDivisionId:function(){
            activeInstance.selectedActivityId = -1;

            activeInstance.divisions.forEach(function(record){
                if(activeInstance.activeDivisionId == record.id){
                    activeInstance.activeDivision = record;
                }
            });
        }
    },
    created:function(){
        activeInstance = this;

        showLoadingOverlay();
        axios.get(baseURL + '/ajax/brief/list').then(function(response) {
            $('body').LoadingOverlay("hide");
            activeInstance.brief_fields = response.data;
        });
    },
    methods:{
        strToUrlFriendly: function(str) {
            str = str.replace(/^\s+|\s+$/g, '');
            str = str.toLowerCase();

            var from = "ãàáäâẽèéëêìíïîõòóöőôùúüűûñç·/_,:;";
            var to   = "aaaaaeeeeeiiiioooooouuuuunc------";
            for (var i=0, l=from.length ; i<l ; i++) {
                str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
            }
          
            str = str.replace(/[^a-z0-9 -]/g, '')
                .replace(/\s+/g, '-')
                .replace(/-+/g, '-');
          
            return str;
        },
        insertBrief: function() {
            bootbox.prompt({
                title: 'Brief field létrehozása',
                callback: function(result) {
                    if (result) {
                        axios.post(baseURL + '/ajax/brief/create', {title: result, machine_name: activeInstance.strToUrlFriendly(result)}).then(function(response) {
                            activeInstance.brief_fields.push(response.data);
                        }).catch(function(error) {
                            console.log(error);
                        });
                    }
                }
            });
        },
        edit:function(field) {
            bootbox.prompt({
                title: field.title + " - mező módosítása",
                value: field.title,
                callback: function(result) {
                    if (result) {
                        axios.post(baseURL + '/ajax/brief/update', {id: field.id, title: result, machine_name: activeInstance.strToUrlFriendly(result)}).then(function(response) {
                            field.title = result;
                        }).catch(function(error) {
                            console.log(error);
                        });
                    }
                }
            });
        },
        filterActivitiesByDivision: function(activity){
            var result = false;

            $.each(activeInstance.activeDivision.activity_assignments,function(index,assignment){
                //console.log(assignment);
                if(assignment.activity.id == activity.id){
                    result = true;
                }
            });
            return result;
        }
    }
});